import React from 'react';
import { Box, Modal, Paragraph, Text } from '@zillow/constellation-10';
import { CometUserRoleType } from '@zg-rentals/ts-rental-manager-api-client';
import { useRentalManagerUser } from '@zg-rentals/rental-manager-env';
import BillingConstants from '../../constants/BillingConstants';
import CheckSampleImage from '../../images/Paybycheck@2x.png';
import { emitPayOfflineEvent } from '../../model/ClickstreamEvents';
import { EVENT_IDS } from '../../model/ClickstreamEvents';

const { ZRN_BILLING_EMAIL, ROCKETSHIP_BILLING_EMAIL } = BillingConstants;

export type PaymentInfoModalProps = {
  onClose: () => void;
};

const PaymentInfoModal = ({ onClose }: PaymentInfoModalProps) => {
  const { user } = useRentalManagerUser();
  const isRocketship = !user.roleTypes?.some((role) => role === CometUserRoleType.MULTIFAMILY_CUSTOMER);

  React.useEffect(() => {
    emitPayOfflineEvent({ user });
  }, [user]);

  return (
    <Modal
      body={
        <div data-eventid={EVENT_IDS.PAY_OFFLINE}>
          {!user.features.canAccessInvoicePayments && (
            <>
              <Box css={{ marginBottom: 'xs' }}>
                <Text textStyle="heading-sm">Pay by Credit Card</Text>
              </Box>
              <Text> Please contact Zillow Group Rentals.</Text>
              <Text>
                Tel: 206-757-5194, Email:&nbsp;
                <a href={`mailto:${isRocketship ? ROCKETSHIP_BILLING_EMAIL : ZRN_BILLING_EMAIL}`}>
                  {isRocketship ? ROCKETSHIP_BILLING_EMAIL : ZRN_BILLING_EMAIL}
                </a>
              </Text>
              <hr />
            </>
          )}
          <Box css={{ marginBottom: 'xs' }}>
            <Text textStyle="heading-sm">Pay by Bank Transfer</Text>
          </Box>
          <Paragraph textStyle="body-sm-bold">Bank Name: JP Morgan Chase</Paragraph>
          <Paragraph textStyle="body-sm-bold">Account Name: Zillow, Inc.</Paragraph>
          <Paragraph textStyle="body-sm-bold">Phone number: 833-918-0068</Paragraph>
          <Paragraph textStyle="body-sm-bold">ABA / Routing Number: 325070760</Paragraph>
          <Paragraph textStyle="body-sm-bold">Account Number: 932838573</Paragraph>
          <hr />
          <Text textStyle="heading-sm">Pay by Check</Text>
          <Box css={{ marginBlock: 'xs' }}>
            <Text>
              Please include the invoice number in your check remittance and mail your payment to the following address:
            </Text>
          </Box>
          <Paragraph textStyle="body-sm-bold">Zillow, Inc,</Paragraph>
          <Paragraph textStyle="body-sm-bold">P.O. Box 737412</Paragraph>
          <Paragraph textStyle="body-sm-bold">Dallas, TX 75373-7412</Paragraph>
          <Box css={{ marginBlock: 'xs' }}>
            {/* oxlint-disable-next-line next/no-img-element -- webpack SPA, not a Next.js app; next/image is unavailable */}
            <img src={CheckSampleImage} alt="Sample Check" />
          </Box>
          <Text>{BillingConstants.BILLING_INFO_FOOTNOTE}</Text>
        </div>
      }
      onOpenChange={(val) => {
        if (!val) onClose();
      }}
      open={true}
      size={{ base: 'fullScreen', lg: 'md' }}
    />
  );
};

export default PaymentInfoModal;
